export default {
  'menu.welcome': 'AI智能',
  'menu.home': 'AI智能工具',
  'menu.smartTools': 'AI智能工具',

  'menu.goodsManage': '商品库',
  'menu.goodsList': '商品列表',
  'menu.createGoods': '创建商品',
  'menu.goodsDetail': '商品详情',
  'menu.knowledgeManage': '智能体',
  'menu.knowledgeList': '品牌知识列表',
  'menu.eBusinessModel': '品牌大模型',
  'menu.createKnowledge': '新建知识库',
  'menu.knowledgeDetail': '知识库详情',
  'menu.userManage': '用户管理',
  'menu.userList': '用户列表',
  'menu.createUser': '创建用户',
  'menu.UserDetails': '用户详情',
  // 'menu.dashboard.analysis': '',
  // 'menu.dashboard.monitor': 'Monitor11',
  // 'menu.dashboard.workplace': '',

  'menu.smartPlay': '商品视频',
  'menu.liveList': '视频列表',
  'menu.createLive': '创建视频',
  'menu.productEdit': '商品编辑',
  'menu.test': '音频录制',
  'menu.list.search-list.projects': 'Search List(projects)',

  'menu.smartPic': 'AI智图',
  'menu.picList': '智图列表',
  'menu.replaceCloth': 'AI模特配置',
  'menu.replaceBackdrop': 'AI换背景',

  'menu.interactiveLive': '商品直播',
  'menu.createInteractiveLive': '创建直播',
  'menu.interactiveLiveList': '直播列表',
  'menu.interactiveLiveConfig': '互动直播配置',
  'menu.InteractiveLiveDetail': '直播详情',
  'menu.BarrageDetails': '弹幕详情',
  'menu.interactiveLibrary': '互动库',
  'menu.messageCenter': '消息中心',
  'menu.personalCenter': '个人中心',
  'menu.dataBoard': '数据看板',
  'menu.brandMessage': '品牌信息',
  'menu.createBrand': '创建品牌',

  // 'menu.exception': 'Exception',
  // 'menu.exception.not-permission': '403',
  // 'menu.exception.not-find': '404',
  // 'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发',
  'menu.account': '账户',
  'menu.account.logout': '退出登录',
}
